<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import acpmInvestigationMatrixAPI from "@/services/standards/acpmInvestigation/acpmInvestigationMatrixAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

function blankRow() {
  return {
    origen: "", tipo: null, causa_raiz: "", accion: "", responsable: "",
    fecha_inicio: null, fecha_limite: null, estado: "Abierta", eficacia: "Pendiente",
    evidencia_file: null, _uploading: false,
  };
}

export default {
  page: { title: "Plan de Acción ACPM de Investigaciones" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "7.1.3 Plan de Acción y Seguimiento de ACPM (Investigaciones)",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "7.1.3 Ejecución de ACPM de investigaciones", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      matrixId: this.$route.params.matrix || null,
      catalog: { tipos: [], estados: [], eficacias: [] },
      form: { version: "1.0", fecha: new Date().toISOString().substring(0, 10), observacion: null },
      rows: [blankRow()],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    matrixApi() {
      return {
        pdfUrl: (id) => acpmInvestigationMatrixAPI.pdfUrl(id),
        sign: (id, payload) => acpmInvestigationMatrixAPI.sign(id, payload),
      };
    },
    dashboard() {
      let abiertas = 0, proc = 0, cerradas = 0, eficaces = 0;
      const n = this.rows.length;
      this.rows.forEach((r) => {
        if (r.estado === "Cerrada") cerradas++;
        else if (r.estado === "En proceso") proc++;
        else abiertas++;
        if (r.eficacia === "Eficaz") eficaces++;
      });
      return {
        total: n, abiertas, en_proceso: proc, cerradas,
        pct_cierre: n ? Math.round((cerradas / n) * 100) : 0,
        pct_eficacia: n ? Math.round((eficaces / n) * 100) : 0,
      };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    estadoCls(estado) {
      if (estado === "Cerrada") return "badge-success";
      if (estado === "En proceso") return "badge-warning";
      return "badge-danger";
    },
    addRow() { if (!this.isSigned) this.rows.push(blankRow()); },
    removeRow(idx) {
      if (this.isSigned) return;
      this.rows.splice(idx, 1);
      if (!this.rows.length) this.rows.push(blankRow());
    },
    fileName(url) { return String(url).split("/").pop(); },
    load() {
      if (!this.matrixId) { this.loading = false; return; }
      acpmInvestigationMatrixAPI.get(this.matrixId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.observacion = r.observacion || null;
          this.rows = (r.rows && r.rows.length)
            ? r.rows.map((x) => ({
                ...blankRow(), ...x,
                fecha_inicio: x.fecha_inicio ? String(x.fecha_inicio).substring(0, 10) : null,
                fecha_limite: x.fecha_limite ? String(x.fecha_limite).substring(0, 10) : null,
              }))
            : [blankRow()];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, rows: this.rows };
      const req = this.matrixId ? acpmInvestigationMatrixAPI.update(this.matrixId, payload) : acpmInvestigationMatrixAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 59, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Plan de acción guardado.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.matrixId && res && res.id) {
            this.matrixId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/acpm-inv-matriz/${res.id}` });
            this.load();
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar", "error"); });
    },
    async onEvidenceFile(row, event) {
      if (this.isSigned) return;
      const file = event.target.files[0];
      if (!file) return;
      row._uploading = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/7.1.3/matriz-evidencias/${this.matrixId || "nuevo"}/${Date.now()}_${file.name}`;
        const ok = await uploadDocument(path, file);
        if (!ok) throw new Error("upload");
        row.evidencia_file = `${process.env.VUE_APP_BUCKET}/${path}`;
        Swal.fire({ title: "Evidencia cargada", icon: "success", timer: 1200, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la evidencia", "error");
      } finally {
        row._uploading = false;
        if (event.target) event.target.value = null;
      }
    },
    removeEvidence(row) { if (!this.isSigned) row.evidencia_file = null; },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    acpmInvestigationMatrixAPI.catalog().then((c) => { if (c) this.catalog = { ...this.catalog, ...c }; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Registra el plan de acción y seguimiento de las acciones correctivas, preventivas y de mejora derivadas
                de la investigación de incidentes, accidentes de trabajo y enfermedades laborales. Por cada acción indica
                el evento/investigación de origen, el tipo, la causa raíz, la acción, el responsable, las fechas, el
                estado y la verificación de eficacia. Cada guardado es una versión y puede firmarse; usa "Nueva versión"
                en el listado para conservar el historial en el tiempo.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Crea una "Nueva versión" desde el listado para
              seguir actualizando el plan de acción.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión">
                  <b-form-input type="text" v-model="form.version" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha">
                  <b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required />
                </b-form-group>
                <b-form-group class="col-md-7 px-2" label="Observación">
                  <b-form-input type="text" v-model="form.observacion" :disabled="isSigned" />
                </b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Acciones del plan</h5>
                <span class="small">
                  <span class="badge badge-danger">Abiertas: {{ dashboard.abiertas }}</span>
                  <span class="badge badge-warning">En proceso: {{ dashboard.en_proceso }}</span>
                  <span class="badge badge-success">Cerradas: {{ dashboard.cerradas }}</span>
                  <span class="badge badge-info">% Cierre: {{ dashboard.pct_cierre }}%</span>
                  <span class="badge badge-primary">% Eficacia: {{ dashboard.pct_eficacia }}%</span>
                </span>
              </div>

              <div v-for="(row, idx) in rows" :key="idx" class="border rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Acción #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeRow(idx)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Evento / investigación de origen">
                    <b-form-input v-model="row.origen" :disabled="isSigned" size="sm" placeholder="Ej: AT-2026-014 caída en pasillo" />
                  </b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Tipo de acción">
                    <b-form-select v-model="row.tipo" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                      <b-form-select-option v-for="t in catalog.tipos" :key="t" :value="t">{{ t }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Estado">
                    <b-form-select v-model="row.estado" :disabled="isSigned" size="sm">
                      <b-form-select-option v-for="e in catalog.estados" :key="e" :value="e">{{ e }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Causa raíz">
                    <b-form-input v-model="row.causa_raiz" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Acción a implementar">
                    <b-form-input v-model="row.accion" :disabled="isSigned" size="sm" />
                  </b-form-group>
                </div>
                <div class="form-row align-items-end bg-light rounded py-1">
                  <b-form-group class="col-md-3 px-2" label="Responsable">
                    <b-form-input v-model="row.responsable" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Fecha inicio">
                    <b-form-input type="date" v-model="row.fecha_inicio" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Fecha límite">
                    <b-form-input type="date" v-model="row.fecha_limite" :disabled="isSigned" size="sm" />
                  </b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Eficacia">
                    <b-form-select v-model="row.eficacia" :disabled="isSigned" size="sm">
                      <b-form-select-option v-for="ef in catalog.eficacias" :key="ef" :value="ef">{{ ef }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <div class="col-md-2 px-2 pb-2">
                    <span class="badge" :class="estadoCls(row.estado)">{{ row.estado }}</span>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <b-form-group class="col-md-6 px-2" label="Adjuntar evidencia">
                    <b-form-file :disabled="isSigned || row._uploading" browse-text="Buscar"
                      :placeholder="row._uploading ? 'Subiendo...' : 'Selecciona un archivo...'" @change="onEvidenceFile(row, $event)" size="sm" />
                  </b-form-group>
                  <div class="col-md-6 px-2 pb-2 small">
                    <span v-if="row.evidencia_file">
                      <a :href="row.evidencia_file" target="_blank"><i class="mdi mdi-paperclip"></i> {{ fileName(row.evidencia_file) }}</a>
                      <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0 ml-1" @click="removeEvidence(row)"><i class="mdi mdi-close"></i></button>
                    </span>
                    <span v-else class="text-muted">Sin archivo</span>
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addRow">
                <i class="mdi mdi-plus"></i> Agregar acción
              </button>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && matrixId">
        <h6 class="text-muted small mb-1">Plan de Acción ACPM (Investigaciones)</h6>
        <DocumentActions
          :document-id="Number(matrixId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="matrixApi"
          document-title="Plan de Acción y Seguimiento de ACPM derivadas de investigaciones"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
